import axios from "../../apis/Api";
import { hideLoading, showLoading } from "react-redux-loading-bar";

export const getUserDataCorrection = (cnic) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.get("api/User/GetUserDataCorrection", {
      params: { cnic },
    });

    return data.response;
  } finally {
    dispatch(hideLoading());
  }
};

export const updateUserDataCorrection = (request) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post(
      "api/User/UpdateUserDataCorrection",
      request,
    );

    return data;
  } finally {
    dispatch(hideLoading());
  }
};
